import { useState } from "react";
import { DocArchive, SearchHistory } from "../../axios";
import { DbUtils } from "../../utils/DbUtils";
import { ErrorUtils } from "../../utils/ErrorUtils";
import ArchiveCondition from "../parts/ArchiveCondition";
import ArchiveList from "../parts/ArchiveList";

/**
 * 送信履歴画面用コンポーネント
 * 
 * @returns 
 */
export default function ArchivePage(): JSX.Element {

	/** 検索履歴Id */
	const [searchId, setSearchId] = useState<string | undefined>(undefined);

	/** 送信履歴一覧 */
	const [archives, setArchives] = useState<DocArchive[] | undefined>(undefined);

	/**
	 * 検索時用イベント
	 * 
	 * @param search 
	 */
	const handleSearch = async (search: SearchHistory) => {
		setArchives(undefined);
		void doSearch(search);
	};

	/**
	 * 検索を行う。
	 * 
	 * @param search 
	 * @returns 
	 */
	const doSearch = async (search: SearchHistory) => {
		try {
			const res = await DbUtils.getArchiveApi().searchArchives(search);
			setArchives(res.data.archives);
			setSearchId(res.data.search_id);
		} catch (error) {
			ErrorUtils.alert(error);
		}
	};

	console.log('searchId', searchId);
	console.log('archives', archives);

	// 描画する
	return (
		<>
			<h4>送信履歴</h4>

			<hr />
			<form className="form-horizontal">
				<ArchiveCondition onSearch={handleSearch} />
			</form>

			{searchId != undefined && archives != undefined &&
				<ArchiveList searchId={searchId} archives={archives} />
			}

		</>
	);

}